"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/terms.css") : void 0;

var _nuiWidgets = require("@concur/nui-widgets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TermsPanel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TermsPanel, _React$Component);

  function TermsPanel() {
    _classCallCheck(this, TermsPanel);

    return _possibleConstructorReturn(this, _getPrototypeOf(TermsPanel).apply(this, arguments));
  }

  _createClass(TermsPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showCheckbox = _this$props.showCheckbox,
          checked = _this$props.checked,
          onChange = _this$props.onChange,
          title = _this$props.title,
          description = _this$props.description,
          checkboxId = _this$props.checkboxId;
      var showCheckboxStyle = {
        display: showCheckbox ? 'inline' : 'none'
      };

      var tAndCTitle = _react.default.createElement("div", null, _react.default.createElement("span", {
        className: "t-and-c-title"
      }, title), _react.default.createElement("p", {
        className: "t-and-c-description"
      }, _react.default.createElement("span", null, description)));

      return _react.default.createElement("div", {
        className: "term-item-and-box checkbox"
      }, _react.default.createElement("input", {
        id: checkboxId,
        type: "checkbox",
        checked: checked,
        onChange: onChange,
        style: showCheckboxStyle
      }), _react.default.createElement(_nuiWidgets.SectionExpandable, {
        expanded: false,
        title: tAndCTitle,
        headingLevel: "h3"
      }, _react.default.createElement("div", null, _react.default.createElement("span", {
        className: "terms-panel-children"
      }, this.props.children))));
    }
  }]);

  return TermsPanel;
}(_react.default.Component);

TermsPanel.propTypes = {
  showCheckbox: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  children: _propTypes.default.any,
  title: _propTypes.default.any,
  description: _propTypes.default.any,
  checkboxId: _propTypes.default.string
};
var _default = TermsPanel;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/terms/TermsPanel.js
// module id = 268
// module chunks = 0